export default __webpack_public_path__ + "static/media/widget-increase.3854157b.svg";